const local = {

    en:{
       title: 'SEARCH BY SERIAL NUMBER',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',
   
    form_ttl:"SEARCH BY SERIAL NUMBER",
    msg:"Найдено по запросу:",
    dev_ttl:"Название прибора",
    sn:"SN",
    reg:"РЕГ",
    to:"ДО",

    },

    ru:{
       title: 'ПОИСК ПО СЕРИЙНОМУ НОМЕРУ',
 description: 'регистрация продуктов CONDTROL',
    keywords: 'регистрация, продление гарантии',
    
    form_ttl:"ПОИСК ПО СЕРИЙНОМУ НОМЕРУ",
    msg:"Найдено по запросу:",
    dev_ttl:"Название прибора",
    sn:"SN",
    reg:"РЕГ",
    to:"ДО",

    },

    de:{
       title: 'SUCHE NACH SERIENNUMMER',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',

    form_ttl:"SUCHE NACH SERIENNUMMER",
    msg:"Найдено по запросу:",
    dev_ttl:"Название прибора",
    sn:"SN",
    reg:"РЕГ",
    to:"ДО",

    },

};

export default local;